
export const Leagues = [
    { key: 'americanfootball_nfl', title: 'NFL', group: 'American Football' },
    { key: 'baseball_mlb_world_series_winner', title: 'MLB World Series Winner', group: 'Baseball' },
    { key: 'basketball_nba', title: 'NBA', group: 'Basketball' },
    { key: 'basketball_euroleague', title: 'Basketball Euroleague', group: 'Basketball' },
    { key: 'golf_masters_tournament_winner', title: 'Masters Tournament Winner', group: 'Golf' },
    { key: 'icehockey_nhl', title: 'NHL', group: 'Ice Hockey' },
    { key: 'rugbyleague_nrl', title: 'NRL', group: 'Rugby League' },
    { key: 'rugbyunion_six_nations', title: 'Six Nations', group: 'Rugby Union' },
    { key: 'soccer_epl', title: 'EPL', group: 'Soccer' },
    { key: 'soccer_uefa_champs_league', title: 'UEFA Champions League', group: 'Soccer' },
    { key: 'soccer_spain_la_liga', title: 'La Liga - Spain', group: 'Soccer' },
    { key: 'soccer_germany_bundesliga', title: 'Bundesliga - Germany', group: 'Soccer' },
    { key: 'soccer_italy_serie_a', title: 'Serie A - Italy', group: 'Soccer' },
    { key: 'soccer_france_ligue_one', title: 'Ligue 1 - France', group: 'Soccer' },
    { key: 'soccer_uefa_europa_league', title: 'UEFA Europa League', group: 'Soccer' },
    { key: 'soccer_fifa_world_cup_winner', title: 'FIFA World Cup Winner', group: 'Soccer' },
    { key: 'soccer_conmebol_copa_libertadores', title: 'Copa Libertadores', group: 'Soccer' },
    { key: "soccer_england_league1", group: "Soccer", title: "League 1", description: "EFL League 1" },
    { key: 'BLAST Open', group: 'csgo', title: 'BLAST Open' },
    { key: 'ESL Challenger League', group: 'csgo', title: 'ESL Challenger League' },
    { key: 'ESL Impact League', group: 'csgo', title: 'ESL Impact League' },
    { key: 'United21', group: 'csgo', title: 'United21' },
    { key: 'United21 Season 28', group: 'csgo', title: 'United21 Season 28' },
    { key: 'Gamers Club Liga Série', group: 'csgo', title: 'Gamers Club Liga Série' },
    { key: 'European Pro League', group: 'csgo', title: 'European Pro League' },
    { key: 'EPL World Series', group: 'dota', title: 'EPL World Series' },
    { key: 'A1 Gaming League', group: 'csgo', title: 'A1 Gaming League' },
    { key: 'PGL', group: 'csgo', title: 'PGL' },
    { key: 'ESEA', group: 'csgo', title: 'ESEA' }
  ];
